import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'store';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';
SwiperCore.use([Autoplay]);

var TopNotice = function TopNotice() {
  var _notices$results;

  var notices = useSelector(function (state) {
    return state.community.noticesFixed;
  });
  var data = (_notices$results = notices === null || notices === void 0 ? void 0 : notices.results) !== null && _notices$results !== void 0 ? _notices$results : [];
  return /*#__PURE__*/_jsxs("div", {
    className: "top-notice",
    style: {
      marginBottom: -24
    },
    children: [/*#__PURE__*/_jsx("h3", {
      children: "\uACF5\uC9C0\uC0AC\uD56D"
    }), /*#__PURE__*/_jsx("div", {
      style: {
        height: 19,
        overflow: 'hidden'
      },
      children: /*#__PURE__*/_jsx(Swiper, {
        direction: "vertical",
        height: 19,
        autoplay: true,
        children: data.map(function (_ref) {
          var id = _ref.id,
              title = _ref.title;
          return /*#__PURE__*/_jsx(SwiperSlide, {
            tag: "p",
            children: /*#__PURE__*/_jsx("a", {
              href: "/community/notice/".concat(id),
              children: title
            })
          }, id);
        })
      })
    })]
  });
};

export default TopNotice;